import { Component, OnInit, Inject, OnDestroy, AfterViewInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { OnboardingService } from "../../../services/onboarding.service";
import { SettingsService } from "../../../services/settings.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent } from "src/app/components/snackbar/snackbar.component";
import { LoginModel } from "src/app/models/login.model";
import { AuthService } from "src/app/services/auth.service";
declare var google;

@Component({
  selector: "app-edit-warehouse",
  templateUrl: "./edit-warehouse.component.html",
  styleUrls: ["./edit-warehouse.component.scss"],
})
export class EditWarehouseComponent implements OnInit, OnDestroy, AfterViewInit
{
  warehouseForm: FormGroup;
  uniqueId:boolean = false;
  loadingUniqueId:boolean = false;
  checkedUniqueId:boolean = false;
  setTimeoutInter: any;
  private destroy$ = new Subject<void>();
  availableWherehouses = [];
  countries: any[] = [];
  states: any[] = [];
  spin:boolean= false;
  @ViewChild("addressText") addressText: any;
  addressTypes = [
    { key: "AddressLine", type: "street_number" },
    { key: "AddressLine", type: "route" },
    //{ key: "AddressLine", type: "neighborhood" },
    { key: "address2", type: "sublocality_level_2" },
    { key: "address2", type: "sublocality_level_1" },
    { key: "address2", type: "locality" },
    { key: "city", type: "administrative_area_level_2" },
    { key: "state", type: "administrative_area_level_1" },
    { key: "postal", type: "postal_code" },
    { key: "country", type: "country" },
    { key: "countryCode", type: "country" },
    { key: "longitude", type: "long" },
    { key: "latitude", type: "lat" },
  ];

  address: { [key: string]: string };
  userInfo: LoginModel;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<EditWarehouseComponent>,
    public fb: FormBuilder,
    private onboardingService: OnboardingService,
    private settingsService: SettingsService,
    private snackBar: MatSnackBar,
    private authService: AuthService
  ) {
    this.authService.userInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => (this.userInfo = res));
  }

  ngAfterViewInit(): void {
    this.getPlaceAutocomplete();
  }

  getPlaceAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(
      this.addressText.nativeElement,
      { types: ["address"] }
    );
    google.maps.event.addListener(autocomplete, "place_changed", () => {
      const place = autocomplete.getPlace();
      this.setAddressData(place);
    });
  }

  setAddressData(place): void {
    this.resetAddressData();
    var array=place.adr_address.split(",");
    var location={}
    array.forEach((res)=>{
      var temp = document.createElement('div');
      temp.innerHTML = res;  
      var arr = Array.prototype.map.call(temp.childNodes, function(node) {
        if(node.nodeType === 1 ){
          var className=node.className.replaceAll("-","");
          location[className]=node.textContent
        }
      });
    })
    this.address=location;
   
    this.addressTypes.forEach((res) => {
      let data;
      // if (res.type === "administrative_area_level_1") {
      //   data = place.address_components.find((address) =>
      //     address.types.includes(res.type)
      //   )?.short_name;
      // } else
       if (res.key === "countryCode") {
        data = place.address_components.find((address) =>
          address.types.includes(res.type)
        )?.short_name;
      }else if (res.key === "longitude") {
        this.address[res.key] = place.geometry.location.lng();
      }else if (res.key === "latitude") {
        this.address[res.key] = place.geometry.location.lat();
      }
      // else {
      //   data = place.address_components.find((address) =>
      //     address.types.includes(res.type)
      //   )?.long_name;
      // }
      if (data)
        this.address[res.key] = (data).trim();
    });
    this.warehouseForm.get("Addressln1").setValue(this.address.streetaddress);
    this.warehouseForm.get("CountryCode").setValue(this.address.countryCode);
    this.warehouseForm.get("State").setValue(this.address.region);
    this.warehouseForm.get("Postal").setValue(this.address.postalcode);
    this.warehouseForm.get("City").setValue(this.address.locality);
    this.warehouseForm.get('Latitude').setValue(Number(this.address.latitude));
    this.warehouseForm.get('Longitude').setValue(Number(this.address.longitude)); 
  }

  resetAddressData(): void {
    this.address = {
      streetaddress: "",
      extendedaddress: "",
      address2: "",
      locality: "",
      region: "",
      postalcode: "",
      countryname: "",
      countryCode: "",
    };
  }

  ngOnInit() {
    this.warehouseForm = this.fb.group({
      Id: ["", [Validators.required, Validators.pattern('^[a-zA-Z0-9 ]*$')]],
      Name: ["", [Validators.required]],
      Addressln1: ["", [Validators.required]],
      Addressln2: [""],
      City: ["", [Validators.required]],
      State: ["", [Validators.required]],
      Postal: [null, [Validators.required]],
      CountryCode: ["", [Validators.required]],
      Priority: [1],
      Isfba: [true],
      Isfbm: [false],
      Isvendor: [0],
      Picktp: [0],
      Ispicking: [1],
      Isfbmenonly: [0],
      IsCarriesInventory:[true],
      Latitude:[null],
      Longitude:[null]
    });

    if (this.data.type === "edit") {     
      this.loadEditWarehouse();
    }
    this.warehouseForm.get("Addressln1").valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      if (!value) {
        this.resetAddressData();
      }
    });
  }

  loadEditWarehouse() {
    const tempArray = Object.keys(this.data);
    if (tempArray.indexOf("addName") > -1) {
      tempArray.splice(tempArray.indexOf("addName"), 1);
    }
    let tempObject: any = {};
    tempArray.forEach((key, index) => {
      if (index !== 0) {
        tempObject = {
          ...tempObject,
          ...{
            [key.split("")[0].toUpperCase() + key.split("").slice(1).join("")]:
              this.data[key],
          },
        };
      }
    });
    const addressLine = this.data.addressln1
    tempObject = {
      ...tempObject,
      ...{
        Isfba: this.numberToBoolean(tempObject.Isfba),
        Isfbm: this.numberToBoolean(tempObject.Isfbm),
        IsCarriesInventory:tempObject.IsCarriesInventory,
        Addressln1:  addressLine ,
        AddressLine2:this.data.addressLine2,
      },
    };
    this.warehouseForm.patchValue(tempObject);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  private _countriesFilter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.countries.filter((option) =>
      option.name ? option.name.toLowerCase().includes(filterValue) : []
    );
  }
  private _statesFilter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.states.filter((option) =>
      option.name ? option.name.toLowerCase().includes(filterValue) : []
    );
  }

  getWHPayload() {
    const tempData = this.warehouseForm.value;
    return {
      ...tempData,
      Isfba: this.booleanToNumber(tempData.Isfba),
      Isfbm: this.booleanToNumber(tempData.Isfbm),
      Country: this.address ? this.address.countryname : tempData.CountryCode,
      Addressln1: this.address?.extendedaddress ? this.address.extendedaddress : tempData.Addressln1,
    };
  }

  warehouseFormSubmit() {
    this.spin = true;
    const payload = this.getWHPayload();
      this.onboardingService
      .InsertWarehouse(payload)
      .pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: "center",
            data: {
              title: "Warehouse added successfully.",
              action: "Dismiss",
              type: "success",
            },
          });
          this.spin = false;
          this.dialogRef.close(true);
        },
       error: (err) => {
        this.spin = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: "center",
            data: {
              title: err.error?.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
       }
     });
  }

  updateWarehouseFormSubmit() {
    this.spin = true;
    const payload = this.getWHPayload();
      this.settingsService
      .UpdateWh(payload)
      .pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: "center",
            data: {
              title: "Warehouse has been updated successfully.",
              action: "Dismiss",
              type: "success",
            },
          });
          this.spin = false;
          this.dialogRef.close(true);
        },
       error: (err) => {
        this.spin = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: err.error?.error[0],
            action: "Dismiss",
            type: "error",
          },
        });
       }
     });
  }

  checkId($e) {
    const value = $e.target.value;
    this.uniqueId = false;
    this.checkedUniqueId = false;
    this.loadingUniqueId = true;
    if (value !== "") {
      clearTimeout(this.setTimeoutInter);
      this.setTimeoutInter = setTimeout(() => {
          this.settingsService
          .GetWarehouse(value)
          .pipe(takeUntil(this.destroy$)).subscribe({
            next: (data) => {
              this.loadingUniqueId = false;
              if (data === null) {
                this.uniqueId = true;
                this.checkedUniqueId = true;
              } else {
                this.uniqueId = false;
                this.checkedUniqueId = true;
              }
            },
           error: (err) => {
            this.loadingUniqueId = false;
           }
         });
      }, 1000);
    }
  }

  public booleanToNumber = (data) => (data === false ? 0 : 1);

  public numberToBoolean = (data) => (data === 0 ? false : true);

  dialogAction(e) {
    if (e === "Save") {
      this.warehouseFormSubmit();
    } else if (e === "Update") {
      this.updateWarehouseFormSubmit();
    } else {
      this.close();
    }
  }
  close() {
    this.dialogRef.close();
  }

  displayWith(country) {
    return country ? country.name : country;
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }
}
